export const USER_SSN_STRINGS = {
  title: `For setting up your payment method and tax purposes, we need your\u00a0SSN.`,
  subtitle: `This is your <b>social security number (SSN)</b> or your <b>individual taxpayer identification number\u00a0(ITIN)</b>.`,
  full_ssn_itin: 'Full SSN (Or ITIN)',
};
